import { useMemo } from 'react';
import type { CertificateTemplateResponse } from '../../../data-access/api/responses.js';
import { getDynamicFieldKeysForTemplate, groupFieldsBySection } from '../dynamic-fields.js';
import type { FieldsBySection } from '../types.js';

export function useFieldsBySection(template: CertificateTemplateResponse | null): FieldsBySection {
  return useMemo(() => groupFieldsBySection(getDynamicFieldKeysForTemplate(template)), [template]);
}
